module.exports = __webpack_public_path__ + "static/media/tutorialArrow1.dfe08129.svg";